const PINS = [
  { name: "Kingston upon Thames", x: 496, y: 78 },
  { name: "Surbiton", x: 508, y: 156, anchor: "start", dx: 14 },
  { name: "Thames Ditton", x: 392, y: 168, anchor: "start", dx: 14 },
  { name: "East Molesey", x: 310, y: 126, anchor: "start", dx: 14 },
  { name: "West Molesey", x: 218, y: 134, anchor: "end", dx: -14 },
  { name: "Esher", x: 262, y: 250 },
  { name: "Cobham", x: 90, y: 392 },
];

const HOME = { name: "Molesey", x: 264, y: 126 };

const Pin = ({ x, y, name, anchor = "middle", dx = 0, dy, home = false }) => (
  <g>
    <circle cx={x} cy={y} r={home ? 9 : 6} fill={home ? "#3B82BD" : "#FFFFFF"} stroke="#3B82BD" strokeWidth="2.5" />
    {home && <circle cx={x} cy={y} r="18" fill="none" stroke="#3B82BD" strokeWidth="1.5" opacity="0.4" />}
    <text
      x={x + dx}
      y={dy !== undefined ? y + dy : anchor === "middle" ? y + 26 : y + 5}
      textAnchor={anchor}
      fontFamily="Inter, sans-serif"
      fontSize="15"
      fontWeight="600"
      fill="#12263A"
    >
      {name}
    </text>
  </g>
);

export const AreaMap = () => (
  <div data-slot="IMAGE - MAP" data-testid="area-map" className="relative aspect-[4/3] overflow-hidden rounded-card border border-line bg-alt">
    <svg
      viewBox="0 0 600 450"
      role="img"
      aria-label="Map of the areas DMS Home Improvements covers: Molesey, East Molesey, West Molesey, Kingston upon Thames, Surbiton, Thames Ditton, Esher and Cobham"
      className="h-full w-full"
    >
      <defs>
        <pattern id="grid" width="30" height="30" patternUnits="userSpaceOnUse">
          <path d="M 30 0 L 0 0 0 30" fill="none" stroke="#E5E7EB" strokeWidth="1" />
        </pattern>
      </defs>
      <rect width="600" height="450" fill="url(#grid)" />
      <path d="M -10 70 C 120 40, 230 100, 330 96 S 470 40 500 62 S 560 20 620 -10" fill="none" stroke="#3B82BD" strokeWidth="14" opacity="0.18" strokeLinecap="round" />
      <path d="M 300 96 C 340 130, 360 200, 380 260" fill="none" stroke="#3B82BD" strokeWidth="6" opacity="0.14" strokeLinecap="round" />
      <path d="M 40 440 L 130 300 L 260 250 L 392 168 L 496 78" fill="none" stroke="#12263A" strokeWidth="1.5" strokeDasharray="4 6" opacity="0.35" />
      <text x="24" y="40" fontFamily="Inter, sans-serif" fontSize="12" fontWeight="600" letterSpacing="1.2" fill="#3B82BD">
        RIVER THAMES
      </text>
      {PINS.map((p) => (
        <Pin key={p.name} {...p} />
      ))}
      <Pin {...HOME} home anchor="middle" dy={-28} />
      <text x="576" y="430" textAnchor="end" fontFamily="Inter, sans-serif" fontSize="12" fill="#4B5563">
        Based in Molesey, Surrey
      </text>
    </svg>
  </div>
);
